import { Image, OsModal } from "@outschool/backpack";
import React from "react";

interface ImageModalProps {
  open: boolean;
  onClose: () => void;
  imageUrl: string | undefined;
}

export default function ImageModal({
  open,
  onClose,
  imageUrl,
}: ImageModalProps) {
  if (!imageUrl) {
    return null;
  }
  return (
    <OsModal open={open} onClose={onClose}>
      <Image
        sx={{
          width: "100%",
        }}
        src={imageUrl}
        alt=""
      />
    </OsModal>
  );
}
